import { PractitionerStatus } from "../enums/practitioner-status.enum";

export class Status {
  public createdAt: number;
  public description: string;
  public id: string;
  public practitionerId: string;
  public value: PractitionerStatus;

  constructor(createdAt: number, description: string, status: PractitionerStatus, practitionerId: string, id?: string) {
    this.createdAt = createdAt;
    this.description = description;
    this.practitionerId = practitionerId;
    this.value = status;
    this.id = id;
  }

  public static mapFromFirestore(status: any, id: string): Status {
    return new Status(
      status.createdAt,
      status.description,
      status.practitionerId,
      status.value as PractitionerStatus,
      id
    );
  }

  public mapToFirestore(): any {
    return {
      createdAt: this.createdAt,
      description: this.description,
      practitionerId: this.practitionerId,
      value: this.value
    };
  }

  public static mapArrayFromFirestore(statuses: any[]): Status[] {
    var statusArray: Status[] = [];
    statuses.forEach((status: any) => {
      statusArray.push(Status.mapFromFirestore(status, null));
    });
    return statusArray;
  }

  public static mapArrayToFirestore(statuses: Status[]): any[] {
    var statusArray = [];
    statuses.forEach((status: Status) => {
      statusArray.push(status.mapToFirestore());
    });
    return statusArray;
  }
}
